import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
import BlockTypes from '../../../types/BlockTypes';
export default function moveToRowBelow(editor) {
  if (!editor.isSelectionInTable()) {
    return editor;
  }

  var tableId = editor.getCurrentTableId();
  var cells = editor.getTableCells(tableId);
  var columnCount = getTableColumnCountForCells(cells);
  var activeCellIndex = cells.findIndex(function (cell) {
    return cell === editor.value.endBlock;
  });

  if (activeCellIndex + columnCount < cells.size) {
    return editor.moveTo(cells.get(Math.floor((activeCellIndex + columnCount) / columnCount) * columnCount).getFirstText().key);
  } else {
    if (editor.value.document.getBlocks().last() === cells.last()) {
      return editor.moveTo(cells.last().getFirstText().key).moveToEndOfText().insertBlock(BlockTypes.UNSTYLED);
    } else {
      return editor.moveTo(cells.last().getFirstText().key).moveToStartOfNextText();
    }
  }
}